import { render, staticRenderFns } from "./ProjekteLinks.vue?vue&type=template&id=35ab6b02&scoped=true&"
import script from "./ProjekteLinks.vue?vue&type=script&lang=js&"
export * from "./ProjekteLinks.vue?vue&type=script&lang=js&"
import style0 from "./ProjekteLinks.vue?vue&type=style&index=0&id=35ab6b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ab6b02",
  null
  
)

export default component.exports